// Картата на един отрязък на телефон: първият ред носи кога и колко, вторият —
// сметки, количество и средна сметка. Общата транспозиция „ред на колона" би
// направила от десет колони карта от десет реда.

import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { formatNumber } from "../../../../components/dataTable";
import type { PeriodRow } from "./salesByPeriodsMath";

type Props = { row: PeriodRow };

export const SalesByPeriodsMobileCard = ({ row }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <span className="min-w-0 flex-1 truncate text-[15px] font-bold text-ink">
          {row.label}
          {row.sublabel ? (
            <span className="font-medium text-muted">{` · ${row.sublabel}`}</span>
          ) : null}
        </span>
        <span className="font-pos-mono text-[15px] font-bold tabular-nums text-ink">
          {fmtEuro(row.revenue)}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] font-medium text-muted">
        <span>{`${row.bills} ${t("reportsPage.bills").toLowerCase()}`}</span>
        <span aria-hidden>·</span>
        <span className="font-pos-mono tabular-nums">
          {`${formatNumber(row.quantity)} ${t("reportsPage.salesPeriodsQuantityShort")}`}
        </span>
        <span aria-hidden>·</span>
        <span className="font-pos-mono tabular-nums">
          {`${t("reportsPage.salesPeriodsAvgBillShort")} ${fmtEuro(row.avgBill)}`}
        </span>
      </div>
    </div>
  );
};
